import { customTV } from '../../utils/tailwind';
export const inputWrapper = customTV({
    base: 'text-content-default dark:text-content-default-dark bg-background-overlay dark:bg-background-overlay-dark m-2 flex',
    variants: {
        size: {
            24: 'rounded-xs min-h-24',
            32: 'min-h-32 rounded-sm',
            40: 'min-h-40 rounded-md',
            48: 'min-h-48 rounded-md',
            56: 'min-h-56 rounded-md',
        },
        disabled: {
            true: 'text-content-disabled dark:text-content-disabled-dark bg-background-contrast dark:bg-background-contrast-dark cursor-not-allowed',
        },
        readonly: {
            true: 'text-content-disabled dark:text-content-disabled-dark bg-background-contrast dark:bg-background-contrast-dark',
        },
        withStroke: {
            true: 'outline-border-form dark:outline-border-form-dark outline outline-1',
        },
        withPointer: { true: 'cursor-pointer' },
        isFocused: { false: '' },
        error: { false: '' },
    },
    compoundVariants: [
        {
            withStroke: true,
            isFocused: true,
            className: 'outline-border-selected dark:outline-border-selected-dark outline-2',
        },
        {
            error: true,
            withStroke: true,
            isFocused: false,
            className: 'outline-border-form-critical dark:outline-border-form-critical-dark',
        },
        {
            disabled: true,
            withPointer: true,
            className: 'cursor-not-allowed',
        },
    ],
});
export const inputCentralizer = customTV({
    base: 'relative flex w-full flex-col',
    variants: {
        size: {
            24: 'px-4 py-0',
            32: 'p-4',
            40: 'p-8',
            48: 'p-8',
            56: 'px-16 py-8',
        },
        center: {
            true: 'justify-center',
            false: 'justify-end',
        },
    },
});
export const input = customTV({
    base: 'text-content-default dark:text-content-default-dark disabled:text-content-disabled dark:disabled:text-content-disabled-dark m-0 h-20 w-full border-none bg-transparent p-0 outline-none disabled:cursor-not-allowed',
    variants: {
        placeholderVisible: {
            true: 'placeholder:text-content-placeholder dark:placeholder:text-content-placeholder-dark',
            false: 'placeholder:text-transparent',
        },
    },
});
export const inputLabel = customTV({
    base: 'text-content-placeholder dark:text-content-placeholder-dark  absolute left-0 w-[calc(100%-2rem)] transition-all duration-300 ease-in-out',
    variants: {
        size: {
            24: 'top-0 px-4 py-0',
            32: 'top-0 p-4',
            40: 'top-0 p-8',
            48: 'top-4 p-8',
            56: 'top-8 px-16 py-8',
        },
        withPointer: { true: 'cursor-pointer' },
        shrunk: { true: 'top-0' },
        disabled: { true: 'cursor-not-allowed' },
        withTags: { true: 'py-8' },
        focused: { false: '' },
        error: {
            true: 'text-content-critical dark:text-content-critical-dark',
        },
    },
    compoundVariants: [
        {
            disabled: true,
            focused: false,
            error: false,
            className: 'text-content-disabled dark:text-content-disabled-dark',
        },
        {
            focused: true,
            error: false,
            className: 'text-content-subdued dark:text-content-subdued-dark',
        },
        {
            withPointer: true,
            disabled: true,
            className: 'cursor-not-allowed',
        },
    ],
    defaultVariants: {
        disabled: false,
        focused: false,
        error: false,
    },
});
export const affix = customTV({
    base: 'flex items-center justify-center',
    variants: {
        size: {
            24: '[--affix-space:0.25rem]',
            32: '[--affix-space:0.25rem]',
            40: '[--affix-space:0.5rem]',
            48: '[--affix-space:0.5rem]',
            56: '[--affix-space:1rem]',
        },
        variant: {
            prefix: 'ml-[--affix-space]',
            suffix: 'mr-[--affix-space]',
        },
    },
});
